import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as HomeIcon } from "../../assests/images/home-line.svg";
import {
  accountListSelector,
  selectedAccountSelector,
} from "../../store/selectors/app.selector";
import {
  allowDecimalwithMaxLimit,
  allowOnlyNumbers,
  amountFormat,
} from "../../services/common.service";
import {
  Breadcrumb,
  Button,
  Card,
  Form,
  Input,
  Modal,
  Radio,
  Select,
} from "antd";
import { NumericFormat } from "react-number-format";
import { useNavigate } from "react-router";
import CommonOtp from "../../components/otp";
import { useTranslation } from "react-i18next";
import AccountCard from "../../components/account-card";
import { ReactComponent as TitleIcon } from "../../assests/images/quicktbreadrans.svg";
import AccountDisplay from "../../components/account-display";
import { CONFIG } from "../../environment";
import moment from "moment";
import { ReactComponent as TickIcon } from "../../assests/images/tickIcon.svg";
import AccountSelectedCard from "../../components/account-selected-card";
import SalaryAdvanceService from "../../services/salaryAdvance";

function SalaryAdvanceRepay() {
  const [stage, setStage] = useState(1);
  const accountList = useSelector(accountListSelector);
  const account = accountList?.filter((ele) => ele.accountClass !== "STAFSA");
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [formDetails, setFormDetails] = useState({});
  const [message, setMessage] = useState("");
  const [otp, setOtp] = useState("");
  const { t } = useTranslation();
  const [successVisible, setSuccessVisible] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState("");
  const [maxLoanAmount, setMaxLoanAmount] = useState("");
  const [amountType, setAmountType] = useState("PARTIAL");
  const [dataSource, setDataSource] = useState([]);
  useEffect(() => {
    form.setFieldsValue({
      amountType: "PARTIAL",
    });
  }, []);

  const handleChangeAccount = useCallback(
    async (accountDet) => {
      try {
        const accDetails = account.find((ele) => ele.accountNo === accountDet);
        setSelectedAccount(accDetails);
        const req = {
          accountNumber: accountDet,
        };
        const response = await SalaryAdvanceService.getsalaryAdvanceList(req);
        if (response.status === 200) {
          setDataSource(
            response.data["data"]["salaryAdvanceLoanQueryInfoListResponse"]
          );
        }
      } catch (error) {
        console.log(error);
      }
    },
    [account]
  );

  const handleLoanId = useCallback(
    async (value) => {
      const list = dataSource.find((ele) => ele.loanId === value);
      form.setFieldsValue({
        amountTotal: list.loanAmount,
        amountType: "TOTAL",
        amount: "",
      });
      setAmountType("TOTAL");
      setMaxLoanAmount(list.loanAmount);
    },
    [dataSource]
  );
  const onVerify = useCallback(async (value) => {
    try {
      const amount = value.amount || value.amountTotal;
      const transferAmount =
        typeof amount === "number"
          ? amount
          : parseFloat("" + amount.replaceAll(/,/g, ""));

      const requestParams = {
        amount: transferAmount,
        accountNumber: value.accountNo,
        loanId: value.loanId,
      };
      setFormDetails({
        ...requestParams,
      });
      const response1 = await SalaryAdvanceService.salaryAdvanceLoanRepayVerify(
        requestParams
      );
      if (response1.status === 200) {
        setLoader(false);
        console.log("response1.data", response1.data);
        if (response1.data["otpEnable"]) {
          setStage(2);
        } else {
          await onConfirm({ ...requestParams, otp: CONFIG?.DEFAULT_OTP });
        }
      }
    } catch (error) {
      setLoader(false);
    }
  }, []);

  const onConfirm = useCallback(
    async (value) => {
      try {
        setLoader(true);
        const response =
          await SalaryAdvanceService.salaryAdvanceLoanRepayConfirm({
            amount: formDetails.amount,
            accountNumber: formDetails.accountNo,
            ...value,
          });
        if (response.status === 200) {
          setLoader(false);
          setMessage(response.data["message"]);
          setSuccessVisible(true);
        }
      } catch (error) {
        setLoader(false);
        setOtp("");
      }
    },
    [formDetails]
  );

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm();

      case 2:
        return renderConfirm();

      case 3:
        return (
          <CommonOtp
            otp={otp}
            setOtp={setOtp}
            type="TRANSACTION"
            onConfirm={(values) => onConfirm({ ...formDetails, ...values })}
            handleResendOtp={() => onConfirm()}
            cancelTransaction={() => {
              navigate("/salaray-advance");
            }}
          />
        );

      default:
        return renderForm();
    }
  }

  function renderForm() {
    return (
      <div>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <p className="mb-4">
            {t("common.proceed_fill_txt", {
              defaultValue: "Please fill required details, before you proceed",
            })}
          </p>
        </div>
        <Form onFinish={onVerify} layout="vertical" form={form}>
          <div className="row">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Form.Item
                label="Account Number"
                name="accountNo"
                rules={[
                  {
                    required: true,
                    message: "Account Number is required",
                  },
                ]}
              >
                <Select
                  size="large"
                  optionLabelProp={"value"}
                  showSearch
                  placeholder="Account Number"
                  onChange={handleChangeAccount}
                >
                  {account.map((account, index) => (
                    <Select.Option key={index} value={account.accountNo}>
                      <span className="acc-short-name">
                        {account?.acctShortName}
                      </span>
                      <br />
                      <span style={{ fontSize: "12px" }}>
                        {account?.accountNo}
                      </span>
                      <br />
                      <span style={{ fontSize: "12px" }}>
                        {account?.branchName}
                      </span>
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              {selectedAccount.avlBalance && (
                <p
                  style={{ float: "right", margin: "-10px 5px" }}
                  className="primary-color"
                >
                  {t("common.avl_bal", {
                    defaultValue: "Avl Bal",
                  })}
                  :{" "}
                  <span style={{ marginRight: 5 }}>
                    {selectedAccount?.accountCurrency}
                  </span>
                  <NumericFormat
                    value={selectedAccount?.avlBalance}
                    displayType={"text"}
                    thousandSeparator={true}
                    prefix={""}
                    fixedDecimalScale={true}
                    decimalScale={2}
                    allowEmptyFormatting
                  />
                </p>
              )}
            </div>
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <Form.Item
                label="Investment Id"
                name="loanId"
                rules={[
                  {
                    required: true,
                    message: "Investment Id is required",
                  },
                ]}
              >
                <Select
                  size="large"
                  optionLabelProp={"value"}
                  showSearch
                  placeholder="Investment Id"
                  onChange={handleLoanId}
                >
                  {dataSource.map((option, index) => (
                    <Select.Option key={index} value={option.loanId}>
                      {option?.loanId}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </div>

            <div className="col-6">
              <Form.Item label="" name="amountType">
                <Radio.Group
                  value={amountType}
                  onChange={(e) => setAmountType(e.target.value)}
                  className=" d-flex justify-content-between"
                >
                  <Radio value={"TOTAL"}>Total Amount</Radio>
                  <Radio value={"PARTIAL"}>Partial Amount</Radio>
                </Radio.Group>
              </Form.Item>
            </div>
            {amountType === "PARTIAL" ? (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("common.amount", { defaultValue: "Amount" })}
                  name={"amount"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.amount_required", {
                        defaultValue: "Amount is required",
                      }),
                    },
                    ({ getFieldValue }) => ({
                      validator(rule, value) {
                        if (
                          value === undefined ||
                          value === null ||
                          value === ""
                        ) {
                          return Promise.resolve();
                        }
                        const numericValue = getFieldValue("amount").replaceAll(
                          /,/g,
                          ""
                        );

                        if (numericValue <= 0) {
                          return Promise.reject(
                            t("errorMesssages.amount_valid", {
                              defaultValue: "Amount should be greater than 0",
                            })
                          );
                        }

                        if (maxLoanAmount && numericValue > maxLoanAmount) {
                          return Promise.reject(
                            t("errorMesssages.amount_max", {
                              defaultValue: `Amount should be less than or equal to ${maxLoanAmount}`,
                            })
                          );
                        }

                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <NumericFormat
                    type="tel"
                    placeholder={t("common.amount", {
                      defaultValue: "Amount",
                    })}
                    maxLength={12}
                    allowNegative={false}
                    customInput={Input}
                    thousandSeparator={true}
                    fixedDecimalScale={true}
                    onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                    size="large"
                  />
                </Form.Item>
              </div>
            ) : (
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <Form.Item
                  label={t("common.amount", { defaultValue: "Amount" })}
                  name={"amountTotal"}
                  rules={[
                    {
                      required: true,
                      message: t("errorMesssages.amount_required", {
                        defaultValue: "Amount is required",
                      }),
                    },
                  ]}
                >
                  <NumericFormat
                    type="tel"
                    placeholder={t("common.amount", {
                      defaultValue: "Amount",
                    })}
                    maxLength={12}
                    allowNegative={false}
                    customInput={Input}
                    thousandSeparator={true}
                    fixedDecimalScale={false}
                    onKeyPress={(e) => allowDecimalwithMaxLimit(e)}
                    size="large"
                    readOnly
                  />
                </Form.Item>
              </div>
            )}
          </div>
          <div className="d-flex justify-content-end  mt-3">
            <Button
              onClick={() => navigate("/salaray-advance")}
              type="default"
              className="secondary-btn"
              style={{ marginRight: 20 }}
              size="large"
            >
              {t("buttons.cancel_btn", {
                defaultValue: "Cancel",
              })}
            </Button>
            <Button
              loading={loader}
              type="primary"
              className="primary-btn"
              htmlType="submit"
              size="large"
            >
              {t("buttons.submit_btn", {
                defaultValue: "Submit",
              })}
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  function renderConfirm() {
    return (
      <div>
        <h5 className="mb-3">
          {" "}
          {t("common.confirmation", {
            defaultValue: "Confirmation",
          })}
        </h5>
        <p className="mb-3" style={{ fontSize: 14 }}>
          Please check the details carefully, before you proceed
        </p>

        <div className="confirm-details">
          <div className="row">
            <div className="confirm-label-wrapper">
              <label> Account Number</label>
              <span>{formDetails?.accountNumber}</span>
            </div>
            <div className="confirm-label-wrapper">
              <label>Loan Id</label>
              <span>{formDetails?.loanId}</span>
            </div>
            <div className="confirm-label-wrapper ">
              <label>{t("common.amount", { defaultValue: "Amount" })}</label>
              <span>{amountFormat(formDetails?.amount)}</span>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end mt-4">
          <Button
            onClick={() => setStage(1)}
            type="default"
            style={{ marginRight: 30 }}
            className="secondary-btn"
            size="large"
          >
            {t("buttons.back_btn", {
              defaultValue: "Back",
            })}
          </Button>

          <Button
            onClick={() => setStage(3)}
            loading={loader}
            type="primary"
            className="primary-btn"
            size="large"
          >
            {t("buttons.proceed_btn", {
              defaultValue: "Proceed",
            })}
          </Button>
        </div>
      </div>
    );
  }

  return (
    <>
        <Breadcrumb separator=">">
          {/* <Breadcrumb.Item>
            <span onClick={() => navigate("/dashboard")}>
              <HomeIcon height={14}/>
            </span>
          </Breadcrumb.Item> */}
          <Breadcrumb.Item>
            <span onClick={() => navigate("/salaray-advance")}>
              Salary Advance
            </span>
          </Breadcrumb.Item>

          <Breadcrumb.Item>
            <span>Loan Repay</span>
          </Breadcrumb.Item>
        </Breadcrumb>

      <Card size="small" className="mb-1 text-center breadcrumb-title-card">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 d-flex justify-content-left align-items-center heading mx-0">
            {/* <TitleIcon height={30} style={{ marginLeft: "-20px" }} /> */}
            <h3 className="title mb-0">Loan Repay</h3>
          </div>
        </div>
      </Card>
      <div className="row d-flex justify-content-between">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
          <Card className="application-card card-padding">
            {renderSwitch()}
          </Card>
        </div>
      </div>

      <Modal
        title={""}
        open={successVisible}
        footer={null}
        width={480}
        closable={false}
        maskClosable={false}
        mask={true}
        // className="custom-error-modal"
      >
        <div style={{ margin: "0 auto" }} align="center">
          <TickIcon height={65} />
          <h4 className="mb-3 mt-2">
            {" "}
            {t("common.success", {
              defaultValue: "Success",
            })}
          </h4>
          <p>{message || "Request Submitted Successfully"}</p>

          <div align="center">
            <Button
              size="large"
              style={{ width: 130 }}
              onClick={() => {
                setSuccessVisible(false);
                navigate("/salaray-advance");
              }}
              type="primary"
            >
              {t("buttons.okay_btn", {
                defaultValue: "Okay",
              })}
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default SalaryAdvanceRepay;
